/* ============================================================
   lefelin — Fiche produit « Sérénité »
   Accordéon FAQ + apparition au scroll. Aucune dépendance.
   Le panier / les variantes / le zoom restent gérés par Minimog.
   ============================================================ */
(function () {
  "use strict";

  var reduced =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- FAQ : accordéon (un seul ouvert) ---- */
  function initFaq(root) {
    if (!root || root.dataset.lfInit === "1") return;
    root.dataset.lfInit = "1";

    var items = Array.prototype.slice.call(
      root.querySelectorAll(".lf-faq__item")
    );

    root.addEventListener("click", function (e) {
      var btn = e.target.closest(".lf-faq__q");
      if (!btn) return;
      var item = btn.closest(".lf-faq__item");
      var isOpen = item.classList.contains("is-open");
      items.forEach(function (other) {
        other.classList.remove("is-open");
        var b = other.querySelector(".lf-faq__q");
        if (b) b.setAttribute("aria-expanded", "false");
      });
      if (!isOpen) {
        item.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
      }
    });
  }

  /* ---- Apparition au scroll ---- */
  function initReveal() {
    var els = document.querySelectorAll("body.lefelin .lf-reveal");
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) {
      // Pas d'animation : on laisse tout visible (CSS par défaut).
      return;
    }
    document.body.classList.add("lf-anim");
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-in");
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px", threshold: 0.08 }
    );
    els.forEach(function (el) {
      io.observe(el);
    });
  }

  /* ---- Galerie arche ---- */
  function initGallery(root) {
    if (!root || root.dataset.lfInit === "1") return;
    root.dataset.lfInit = "1";
    var imgs = Array.prototype.slice.call(root.querySelectorAll(".lf-gal__img"));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll(".lf-gal__thumb"));
    var tagEl = root.querySelector("[data-lf-tag-text]");
    function setTag(pos) {
      if (!tagEl) return;
      var act = imgs.filter(function (im) { return im.getAttribute("data-pos") === String(pos); })[0];
      var t = act && act.getAttribute("data-tag");
      if (t) tagEl.textContent = t;
    }
    if (imgs.length < 2 && thumbs.length < 2) {
      root._lfActivate = function () {};
      return;
    }
    function activate(pos) {
      imgs.forEach(function (im) {
        im.classList.toggle("is-active", im.getAttribute("data-pos") === String(pos));
      });
      thumbs.forEach(function (t) {
        t.classList.toggle("is-active", t.getAttribute("data-pos") === String(pos));
      });
      setTag(pos);
    }
    function current() {
      var a = root.querySelector(".lf-gal__img.is-active");
      return a ? parseInt(a.getAttribute("data-pos"), 10) : 1;
    }
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        activate(t.getAttribute("data-pos"));
      });
    });
    var prev = root.querySelector("[data-lf-prev]");
    var next = root.querySelector("[data-lf-next]");
    var n = imgs.length;
    if (prev) prev.addEventListener("click", function () { activate(((current() - 2 + n) % n) + 1); });
    if (next) next.addEventListener("click", function () { activate((current() % n) + 1); });
    root._lfActivate = activate;
  }

  /* ---- Variantes (swatches → prix / dispo / image) ---- */
  function initVariants(script) {
    if (!script || script.dataset.lfInit === "1") return;
    script.dataset.lfInit = "1";
    var variants;
    try { variants = JSON.parse(script.textContent); } catch (e) { return; }
    var section = script.closest(".lf-hero") || script.parentElement;
    if (!section) return;
    var idInput = section.querySelector("[data-lf-id]");
    var priceEl = section.querySelector("[data-lf-price]");
    var compareEl = section.querySelector("[data-lf-compare]");
    var saveEl = section.querySelector("[data-lf-save]");
    var atc = section.querySelector("[data-lf-atc]");
    var atcText = section.querySelector("[data-lf-atc-text]");
    var stockDot = section.querySelector("[data-lf-stock] .lf-dot");
    var stockText = section.querySelector("[data-lf-stock-text]");
    var gallery = section.querySelector("[data-lf-gallery]");
    var groups = Array.prototype.slice.call(section.querySelectorAll("[data-lf-optgroup]"));

    function selectedOptions() {
      return groups.map(function (g) {
        var sel = g.querySelector(".lf-chip.is-sel");
        return sel ? sel.getAttribute("data-value") : null;
      });
    }
    function match(opts) {
      return variants.find(function (v) {
        return v.options.length === opts.length && v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function apply(v) {
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (compareEl) {
        if (v.compare && v.save) { compareEl.textContent = v.compare; compareEl.removeAttribute("hidden"); }
        else compareEl.setAttribute("hidden", "");
      }
      if (saveEl) {
        if (v.save) { saveEl.textContent = "Économisez " + v.save; saveEl.removeAttribute("hidden"); }
        else saveEl.setAttribute("hidden", "");
      }
      if (atc) {
        atc.disabled = !v.available;
        if (atcText) atcText.textContent = v.available ? "Ajouter au panier" : "Bientôt de retour";
      }
      if (stockDot) stockDot.classList.toggle("lf-dot--off", !v.available);
      if (stockText) stockText.textContent = v.available ? "En stock" : "Bientôt de retour";
      if (v.media && gallery && gallery._lfActivate) gallery._lfActivate(v.media);
    }

    groups.forEach(function (g) {
      g.addEventListener("click", function (e) {
        var chip = e.target.closest(".lf-chip");
        if (!chip) return;
        g.querySelectorAll(".lf-chip").forEach(function (c) { c.classList.remove("is-sel"); });
        chip.classList.add("is-sel");
        var lab = g.querySelector("[data-lf-optval]");
        if (lab) lab.textContent = chip.getAttribute("data-value");
        apply(match(selectedOptions()));
      });
    });
  }

  /* ---- Acheter maintenant (ajoute au panier puis va au checkout) ---- */
  function initBuyNow() {
    document.querySelectorAll("[data-lf-buynow]").forEach(function (btn) {
      if (btn.dataset.lfInit === "1") return;
      btn.dataset.lfInit = "1";
      btn.addEventListener("click", function () {
        var scope = btn.closest(".lf-buy") || document;
        var form = scope.querySelector("form");
        if (!form) return;
        var idEl = form.querySelector("[name=id]");
        var qtyEl = form.querySelector("[name=quantity]");
        var id = idEl && idEl.value;
        var qty = (qtyEl && qtyEl.value) || 1;
        if (!id) return;
        btn.disabled = true;
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: id, quantity: qty }),
        })
          .then(function () { window.location.href = "/checkout"; })
          .catch(function () { btn.disabled = false; });
      });
    });
  }

  /* ---- Onglets « En détail » ---- */
  function initTabs(root) {
    if (!root || root.dataset.lfInit === "1") return;
    root.dataset.lfInit = "1";
    var btns = Array.prototype.slice.call(root.querySelectorAll("[data-lf-tab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-lf-panel]"));
    // Précharge les images des onglets masqués en tâche de fond (après l'affichage
    // du 1er onglet) → le changement de slide devient instantané, sans pénaliser
    // le chargement initial de la page. Les images cachées en `lazy` ne se
    // téléchargeaient qu'au clic, d'où la latence ressentie.
    var preloadPanels = function () {
      panels.forEach(function (p) {
        var img = p.querySelector("img");
        if (img && img.getAttribute("loading") === "lazy") {
          img.setAttribute("loading", "eager");
        }
      });
    };
    if ("requestIdleCallback" in window) {
      requestIdleCallback(preloadPanels, { timeout: 1800 });
    } else {
      setTimeout(preloadPanels, 700);
    }
    root.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-lf-tab]");
      if (!btn) return;
      var k = btn.getAttribute("data-lf-tab");
      btns.forEach(function (b) {
        var on = b.getAttribute("data-lf-tab") === k;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        p.classList.toggle("is-active", p.getAttribute("data-lf-panel") === k);
      });
    });
  }

  /* ---- Barre sticky mobile (prix + ajout panier) ----
     Montrée uniquement quand le bloc d'achat principal est passé AU-DESSUS du
     viewport (pas avant qu'on l'ait atteint). Le bouton délègue au vrai submit
     du formulaire ; prix/libellé/disabled restent synchronisés via
     MutationObserver (initVariants met à jour la carte d'achat). */
  function initStickyAtc(root) {
    var sticky = root.querySelector("[data-lf-sticky]");
    var actions = root.querySelector(".lf-actions");
    var realBtn = root.querySelector("[data-lf-atc]");
    if (!sticky || !actions || !realBtn) return;
    if (sticky.dataset.lfInit === "1") return;
    sticky.dataset.lfInit = "1";
    if (!("IntersectionObserver" in window)) return;
    var sBtn = sticky.querySelector("[data-lf-sticky-atc]");
    var sPrice = sticky.querySelector("[data-lf-sticky-price]");
    var sText = sticky.querySelector("[data-lf-sticky-text]");
    var sync = function () {
      var price = root.querySelector("[data-lf-price]");
      var label = root.querySelector("[data-lf-atc-text]");
      if (price && sPrice) sPrice.textContent = price.textContent;
      if (label && sText) sText.textContent = label.textContent;
      if (sBtn) sBtn.disabled = realBtn.disabled;
    };
    if ("MutationObserver" in window) {
      var card = root.querySelector(".lf-card") || root;
      new MutationObserver(sync).observe(card, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ["disabled"],
      });
    }
    if (sBtn) {
      sBtn.addEventListener("click", function () {
        realBtn.click();
      });
    }
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.hidden = false;
      sticky.classList.toggle("is-shown", passed);
      sticky.setAttribute("aria-hidden", passed ? "false" : "true");
    });
    io.observe(actions);
  }

  function boot() {
    document.querySelectorAll("[data-lf-tabs]").forEach(initTabs);
    document.querySelectorAll("[data-lf-gallery]").forEach(initGallery);
    document.querySelectorAll("[data-lf-variants]").forEach(initVariants);
    document.querySelectorAll("[data-lf-faq]").forEach(initFaq);
    document.querySelectorAll(".lf-hero").forEach(initStickyAtc);
    initBuyNow();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Ré-init après rechargement de section dans l'éditeur de thème */
  document.addEventListener("shopify:section:load", boot);
})();

